import type { TypedUseSelectorHook } from "react-redux";
import { useSelector } from "react-redux";
import type { RootState } from "src/store/RootStore";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
